var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgPortIcon = function SvgPortIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14V8h-4V4H8V1H0v6h3v1H2v1h4V8H5V7h3V5h3v3H8v6h3v1h-1v1h4v-1h-1v-1zM7 6H1V2h6zm2 7V9h6v4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPortIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;